import { render, staticRenderFns } from "./GoalRating.vue?vue&type=template&id=2de0ab6f&scoped=true"
import script from "./GoalRating.vue?vue&type=script&lang=js"
export * from "./GoalRating.vue?vue&type=script&lang=js"
import style0 from "./GoalRating.vue?vue&type=style&index=0&id=2de0ab6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de0ab6f",
  null
  
)

export default component.exports